import { render } from "./StockTransfersView.vue?vue&type=template&id=256272d9"
import script from "./StockTransfersView.vue?vue&type=script&lang=js"
export * from "./StockTransfersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__